import { useEffect } from 'react';
import dayjs from 'dayjs';
import { Text } from '@frontend/design-system';
import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { BaseEventTooltip } from './base-event-tooltip';

interface Props {
  hoveredEventId?: string;
  hoverTime: string;
}

export const EventTooltipContent = ({ hoveredEventId, hoverTime }: Props) => {
  const hoveredEvent = useCalendarGridStore((state) => (hoveredEventId ? state.eventsById[hoveredEventId] : undefined));
  const renderEventTooltipRef = useCalendarGridStore((state) => state.renderEventTooltipRef);
  const isDebugMode = useCalendarGridStore((state) => state.debug);

  useEffect(() => {
    if (isDebugMode) {
      console.debug('hoveredEvent (debug mode)::', hoveredEvent);
    }
  }, [isDebugMode, hoveredEvent]);

  if (!hoveredEvent) return <Text>{hoverTime}</Text>;

  if (renderEventTooltipRef?.current && typeof renderEventTooltipRef.current === 'function') {
    const content = renderEventTooltipRef.current(hoveredEvent);
    if (content) return content;
  }

  const title =
    hoveredEvent.eventType === 'exceptionV3' || hoveredEvent.eventType === 'exceptionV2' ? hoveredEvent.title : '';

  const startTime = dayjs(hoveredEvent.startTime, 'HH:mm');
  const durationText = `${startTime.format('h:mm A')} - ${startTime
    .add(hoveredEvent.duration ?? 0, 'minute')
    .format('h:mm A')}`;

  return (
    <BaseEventTooltip>
      {title && <BaseEventTooltip.Text isPrimary>{title}</BaseEventTooltip.Text>}
      <BaseEventTooltip.Text>{durationText}</BaseEventTooltip.Text>
    </BaseEventTooltip>
  );
};
